// Formats a typed income as Chilean pesos, e.g. "1000000" -> "$ 1.000.000".
export const formatIncomeAmount = (value) => {
  const digits = `${value ?? ''}`.replace(/[^0-9]/g, '');
  if (!digits) return '';
  return `$ ${digits}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

// Reverts formatIncomeAmount; returns null when there are no digits.
export const parseIncomeAmount = (value) => {
  const digits = `${value ?? ''}`.replace(/[^0-9]/g, '');
  return digits ? Number(digits) : null;
};

// The backend requires the income per policy and group, so any coverage of a
// selected group whose capital depends on the income makes it required.
export const selectedGroupsRequireIncome = (policies = []) =>
  policies.some((policy) => {
    const selectedGroups = new Set(
      (policy.groupCompanies || []).map((groupCompanyId) =>
        Number(groupCompanyId)
      )
    );
    return (policy.coverageOptions || []).some(
      (coverage) =>
        coverage.requiresIncome === true &&
        selectedGroups.has(Number(coverage.groupCompanyId))
    );
  });
